<template>
  <div class="list-block vh91">
    <div v-for="(item, index) in ids" :key="index" :class="{ bottom10: index < 2 }">
      <div v-if="searchId(item, '180002')">
        <Title>储能效率统计</Title>
        <BlockXiaolu></BlockXiaolu>
      </div>
      <div v-if="searchId(item, '90005')">
        <Title>日充放电量（kWh）</Title>
        <Block>
          <div class="s-row richongfang" @click="navigateToOtherPage('日充放电量')">
            <EchartsPie ref="dayPie" :data="dayChargingStatisticsData" eid="dayPie" :menuType="'menuType'"></EchartsPie>
          </div>
        </Block>
      </div>
      <div v-if="searchId(item, '90006')">
        <Title>收益统计</Title>
        <Block>
          <template v-if="isGDS">
            <div class="s-row" style="display: flex;">
              <SmallBlockB :data="incomeData.incomeData01" color="blue"></SmallBlockB>
              <SmallBlockB :data="incomeData.incomeData02" color="yellow"></SmallBlockB>
            </div>
            <div class="pagoda-wrap" @click="navigateToOtherPage('收益统计')">
              <EchartsPie ref="incomeChart" :data="echartsPagodaData" eid="incomeChart" :menuType="'menuType'"></EchartsPie>
            </div>
          </template>
          <template v-else>
            <div class="shouyi">
              <span class="income-data">
                <div class="income-title">{{ incomeTotal }}</div>
                <div class="income-number">{{ echartsPagodaData.income }}</div>
            </span>
            </div>
            <div class="pagoda-wrap" @click="navigateToOtherPage('收益统计')">
              <EchartsPagoda ref="incomeChart" :data="echartsPagodaData"></EchartsPagoda>
            </div>
          </template>
        </Block>
      </div>
      <div v-if="searchId(item, '90007')">
        <Title>光伏统计</Title>
        <Block>
          <div class="s-row">
            <SmallBlock :data="gfData.todayEnergy" color="blue" style="width: 200px;"></SmallBlock>
            <SmallBlock :data="gfData.totalEnergy" color="blue" style="width: 200px;"></SmallBlock>
          </div>
          <div class="s-row guangfu">
            <EchartsLine ref="gfEchartsLine" :data="gfEchartsLineData" eid="gfEchartsLine"></EchartsLine>
          </div>
        </Block>
      </div>
      <div v-if="searchId(item, '90008')">
        <Title>储能统计</Title>
        <Block>
          <div class="s-row" style="display: flex;">
            <SmallBlock :data="cnData.sbData01" color="blue"></SmallBlock>
            <SmallBlock :data="cnData.sbData02" color="yellow"></SmallBlock>
            <SmallBlock :data="cnData.sbData03" color="blue"></SmallBlock>
          </div>
          <div class="s-row down-block-wrap">
            <SmallBlock :data="cnData.sbData04" color="blue"></SmallBlock>
            <SmallBlock :data="cnData.sbData05" color="yellow"></SmallBlock>
            <div style="display: flex;">
              <SmallBlock :data="cnData.sbData06" color="blue" class="s-block"></SmallBlock>
              <SmallBlock :data="cnData.sbData07" color="blue" class="s-block"></SmallBlock>
            </div>
          </div>
          <div class="s-row echarts-line-wrap">
            <EchartsLine ref="cnEchartsLine" :data="echartsLineData" eid="cnEchartsLine"></EchartsLine>
          </div>
        </Block>
      </div>
      <div v-if="searchId(item, '90009')">
        <Title>并网点功率曲线</Title>
        <Block>
          <div class="s-row shidian">
            <EchartsLine ref="sdEchartsLine" :data="sdEchartsLineData" eid="sdEchartsLine"></EchartsLine>
          </div>
        </Block>
      </div>
      <div class="l-row-cn" v-if="searchId(item, '90010')">
        <Title>光伏统计</Title>
        <Block>
          <div class="s-row">
            <SmallBlock :data="gfData.todayEnergy" color="blue" style="width: 200px;"></SmallBlock>
            <SmallBlock :data="gfData.totalEnergy" color="blue" style="width: 200px;margin: 0px 5px;"></SmallBlock>
            <SmallBlock :data="gfData.solarEfficiency" color="blue" style="width: 200px;"></SmallBlock>
          </div>
          <div class="s-row guangfu">
            <EchartsLine ref="gfEchartsLine" color="#EFA544" :data="gfEchartsLineData" eid="gfEchartsLine">
            </EchartsLine>
          </div>
        </Block>
      </div>
      <div v-if="searchId(item, '90011')" style="position: relative;clear: both;">
        <Title>能耗统计</Title>
        <Block style="height: 250px;">
          <WEchartsPie2 class="annular-wrap" eid="echart-annular" ref="echartAnnular" :data="annularData">
          </WEchartsPie2>
          <img class="bk-img" src="/static/images/svolt/nanwang/bk.png" />
        </Block>
      </div>
      <!-- <div class="l-row" style="height: auto;" v-if="searchId(item, '30241')">
      <Title>智能用能终端装机规模</Title>
      <BlockGuimo :data="guimoData"></BlockGuimo>
    </div> -->
      <!-- 阿尔派项目-->
      <div class="l-row" style="height: auto;" v-if="searchId(item, '90012')">
        <Title>智能用能终端装机规模</Title>
        <BlockGuimo :data="energyStorageData" type="2"></BlockGuimo>
      </div>
      <!-- 蓝思项目-->
      <div class="l-row" style="height: auto;" v-if="searchId(item, '90013')">
        <Title>智能用能终端装机规模</Title>
        <BlockGuimo :data="energyBlockData" type="3"></BlockGuimo>
      </div>
      <div v-if="searchId(item, '90014') || searchId(item, '90015')" style="position: relative;clear: both;">
        <Title>并网点数据</Title>
        <Block class="top-block-height">
          <CityElectricity :data="cityElectricityData"></CityElectricity>
        </Block>
      </div>
      <div class="l-row-cn" v-if="searchId(item, '150002')">
        <Title>储能统计</Title>
        <Block>
          <div class="s-row" style="display: flex;">
            <SmallBlockB :data="cnData.sbData01" color="blue"></SmallBlockB>
            <SmallBlockB :data="cnData.sbData02" color="yellow"></SmallBlockB>
          </div>
          <div class="s-row mg2" style="display: flex;">
            <SmallBlockB :data="cnData.sbData04" color="blue"></SmallBlockB>
            <SmallBlockB :data="cnData.sbData05" color="yellow"></SmallBlockB>
          </div>
          <div class="s-row echarts-line-wrap">
            <EchartsLine ref="cnEchartsLine" color="#19a3df" :data="echartsLineData" eid="cnEchartsLine"></EchartsLine>
          </div>
        </Block>
      </div>

      <!-- <div style="position: relative;clear: both;" v-if="searchId(item, '30240')">
      <Title>智慧用能分项收益统计</Title>
      <Block style="height: 250px;">
        <WEchartsPie ref="incomePiex" :data="wechartsPieData"></WEchartsPie>
        <img class="bk-img" src="/static/images/svolt/nanwang/bk.png" />
      </Block>
    </div> -->
      <!-- <div style="position: relative;clear: both;" v-if="searchId(item, '30246')">
      <Title>充电桩统计</Title>
      <Block>
        <BlockChongdianzhuang :data="cdzData"></BlockChongdianzhuang>
      </Block>
    </div> -->
    </div>
  </div>
</template>

<script>
  import PROJECTAPI from '@/api/svolt/project';
  import {
    getInfo
  } from '@/utils/auth';
  import Block from './block';
  import Title from './title';
  import BlockGuimo from './block-guimo';
  import BlockXiaolu from './block-xiaolu';
  import CityElectricity from './city-electricity';
  import BlockChuneng from './block-chuneng';
  import BlockChongdianzhuang from './block-chongdianzhuang';
  import EchartsPagoda from './echarts-pagoda.vue';
  import EchartsPie from './echarts-pie.vue';
  import SmallBlock from './small-block';
  import SmallBlockB from './small-block-b';
  // import WEchartsPie from './w-echarts-pie';
  import WEchartsPie2 from './w-echarts-pie2';
  import EchartsLine from './echarts-line.vue';
  export default {
    name: 'MixChart',
    components: {
      Block,
      Title,
      SmallBlock,
      SmallBlockB,
      EchartsLine,
      BlockChuneng,
      BlockGuimo,
      CityElectricity,
      // WEchartsPie,
      BlockChongdianzhuang,
      EchartsPagoda,
      EchartsPie,
      WEchartsPie2,
      BlockXiaolu
    },
    props: {
      ids: [],
      panelIds: []
    },
    data() {
      return {
        interval: null,
        idArray: [],
        wechartsPieData: {
          pieData: [{
            value: 0,
            name: '充电桩收益',
            label: {
              color: '#F09D3D'
            }
          },
            {
              value: 0,
              name: '储能收益',
              label: {
                color: '#033A7C'
              }
            },
            {
              value: 0,
              name: '光伏收益',
              label: {
                color: '#19CAE4'
              }
            }
          ]
        },
        activeProject: 'projectHome',
        cnData: {
          sbData01: {
            title: '当日充电量',
            number: '0',
            unit: ''
          },
          sbData02: {
            title: '当日放电量',
            number: '0',
            unit: ''
          },
          sbData03: {
            title: '综合效率',
            number: '0%',
            unit: ''
          },
          sbData04: {
            title: '累计充电量',
            number: '0',
            unit: ''
          },
          sbData05: {
            title: '累计放电量',
            number: '0',
            unit: ''
          },
          sbData06: {
            title: 'SOC',
            number: '0%',
            unit: ''
          },
          sbData07: {
            title: 'SOH',
            number: '0%',
            unit: ''
          }
        },
        incomeData: {
          incomeData01: {
            title: '昨日收益',
            number: '-',
            unit: '元'
          },
          incomeData02: {
            title: '累计收益',
            number: '-',
            unit: '万元'
          },
        },
        gfData: {
          todayEnergy: {
            title: '今日发电量',
            number: '0',
            unit: 'kWh'
          },
          totalEnergy: {
            title: '累计发电量',
            number: '0',
            unit: 'kWh'
          },
          solarEfficiency: {
            title: '发电效率',
            number: '0',
            unit: '%'
          }
        },
        gfEchartsLineData: {
          xLabel: [],
          xValue: []
        },
        echartsLineData: {},
        cityElectricityData: {
          upData: [{
            number: '0',
            title: '正向有功总电能(kWh)'
          }, {
            number: '0',
            title: '反向有功总电能(kWh)'
          }],
          downData: [
            [{
              title: 'P (kW)',
              number: ''
            }, {
              title: 'Q (kVar)',
              number: ''
            }, {
              title: 'Cos',
              number: ''
            }],
            [{
              title: 'Ia (A)',
              number: ''
            }, {
              title: 'Ib (A)',
              number: ''
            }, {
              title: 'Ic (A)',
              number: ''
            }],
            [{
              title: 'Uab (V)',
              number: ''
            }, {
              title: 'Ubc (V)',
              number: ''
            }, {
              title: 'Uca(V)',
              number: ''
            }]
          ]
        },
        //储能容量
        energyStorageData: {},
        authority: [], //权限列表
        incomeTotal: '总收益(元)',
        //收益统计
        echartsPagodaData: {
          income: '0',
          xAxis: [],
          series: []
        },
        //光伏储能总容量-蓝思
        energyBlockData: [{
          key: 'solarVolume',
          title: '光伏总容量',
          unit: '(MW)',
          data: '0'
        }, {
          key: 'energyVolume',
          title: '储能总容量',
          unit: '(kW/kWh)',
          data: '0/0'
        }],
        //日充放电
        dayChargingStatisticsData: {},
        menuType: 'project',
        //规模统计数据
        guimoData: {
          energyStoragePower: {
            number: 0,
            title: '储能总容量',
            unit: 'kW'
          },
          energyStorageCapacity: {
            number: 0,
            title: '储能总容量',
            unit: 'kWh'
          },
          solarCapacity: {
            number: 0,
            title: '光伏总容量',
            unit: 'kW'
          },
          chargingPileCapacity: {
            number: 0,
            title: '充电桩总容量',
            unit: 'kW'
          }
        },
        //市电曲线
        sdEchartsLineData: {
          xLabel: [],
          xValue: []
        },
        //充电桩数据
        cdzData: {
          chargingPileDataList: [{
            dailyEnergy: '0',
            name: '1#充电桩',
            totalEnergy: '0'
          },
            {
              dailyEnergy: '0',
              name: '2#充电桩',
              totalEnergy: '0'
            },
            {
              dailyEnergy: '0',
              name: '3#充电桩',
              totalEnergy: '0'
            }
          ],
          echartsData: {
            xLabel: [],
            xValue: []
          }
        },
        annularData: {
          pieData: []
        },
        orderIds: [],
        isGDS: false,   // 是否万国数据项目
      };
    },
    methods: {
      //初始数据
      init() {
        this.activeProject = this.$route.query.appid || 'projectHome';
        let tempAuth = localStorage.getItem('ActiveProjectModule');
        if (tempAuth) {
          let json = JSON.parse(tempAuth);
          this.authority = [];
          this.idArray = [];
          json.item.forEach(item => {
            if (item.showOrder > 0 && item.showOrder < 9) {
              this.authority.push({
                showOrder: item.showOrder,
                resourceId: item.resourceId,
                resourceNameShow: item.resourceNameShow
              });
              this.idArray.push(item.resourceId);
            }
          });
          // console.log(this.idArray, 'idArray');
          this.getUserInfo();
          //日充放电量
          if (this.orderIds.includes(90005)) {
            this.searchEnergyStorageChargeAndDischargeColumnChart();
          }
          //收益统计
          if (this.orderIds.includes(90006)) {
            this.searchEnergyStorageIncomeStatisticsColumnChart();
          }
          //光伏统计
          if (this.orderIds.includes(90007) || this.orderIds.includes(90010)) {
            this.searchSolarStatistics();
          }
          //储能统计
          if (this.orderIds.includes(90008)) {
            this.searchEnergyStorageStatistics();
          }
          //并网点功率曲线
          if (this.orderIds.includes(90009)) {
            this.searchElectricSupplyPowerCurves();
          }
          //能耗统计
          if (this.orderIds.includes(90011)) {
            this.searchEnergyConsumptionStatistics();
          }
          //装机规模-阿尔派
          if (this.orderIds.includes(90012)) {
            this.searchEnergyStorageVolume();
          }
          if (this.orderIds.includes(90013)) {
            this.searchSolarAndEnergyStorageVolume();
          }
          //并网点数据
          if (this.orderIds.includes(90014) || this.orderIds.includes(90015)) {
            this.searchElectricSupplyStatistics();
          }
          //储能统计
          if (this.orderIds.includes(150002)) {
            this.energyStorageStatisticsExcludeSOC();
          }

          //装机规模
          if (this.idArray.includes(30214)) {
            this.statisticalCapacityByProject();
          }
          //智慧运能分项收益统计
          // this.projectEarningsStatistics();
          //充电桩
          // this.chargingPileStatistics();
        }
      },
      //光伏总容量与储能总容量
      searchSolarAndEnergyStorageVolume() {
        let params = {
          projectId: this.projectId
        };
        PROJECTAPI.searchSolarAndEnergyStorageVolume(params).then(res => {
          if (res.data.code == 200 && !res.data.errors) {
            this.energyBlockData.map(item => {
              item.data = res.data.data[item.key];
            });
          }
        });
      },
      //智能用装机规模
      statisticalCapacityByProject() {
        let tmpData = {};
        let params = {
          projectId: this.projectId
        };
        PROJECTAPI.statisticalCapacityByProject(params).then(res => {
          if (res.data.code == 200) {
            tmpData = res.data.data;
            if (tmpData && tmpData.hasOwnProperty('energyStoragePower')) {
              this.guimoData.energyStoragePower.number = tmpData.energyStoragePower;
              this.guimoData.energyStoragePower.title = '储能总容量';
              this.guimoData.energyStoragePower.unit = tmpData.powerUnit;
            }
            if (tmpData && tmpData.hasOwnProperty('energyStorageCapacity')) {
              this.guimoData.energyStorageCapacity.number = tmpData.energyStorageCapacity;
              this.guimoData.energyStorageCapacity.title = '储能总容量';
              this.guimoData.energyStorageCapacity.unit = tmpData.storageUnit;
            }
            if (tmpData && tmpData.hasOwnProperty('solarCapacity')) {
              this.guimoData.solarCapacity.number = tmpData.solarCapacity;
              this.guimoData.solarCapacity.title = '光伏总容量';
              this.guimoData.solarCapacity.unit = tmpData.solarUnit;
            }
            if (tmpData && tmpData.hasOwnProperty('chargingPileCapacity')) {
              this.guimoData.chargingPileCapacity.number = tmpData.chargingPileCapacity;
              this.guimoData.chargingPileCapacity.title = '充电桩总容量';
              this.guimoData.chargingPileCapacity.unit = tmpData.chargingPileUnit;
            }
          }
        });
      },
      //智能用装机规模-阿尔派
      searchEnergyStorageVolume() {
        let params = {
          projectId: this.projectId
        };
        PROJECTAPI.searchEnergyStorageVolume(params).then(res => {
          if (res.data.code == 200) {
            this.energyStorageData = res.data.data;
          }
        });
      },
      //储能统计
      energyStorageStatisticsExcludeSOC() {
        let params = {
          projectId: this.projectId
        };
        PROJECTAPI.energyStorageStatisticsExcludeSOC(params).then(res => {
          if (res.data.code == 200) {
            let result = res.data.data;
            if (result && result.powerLine) {
              let powerLine = result.powerLine;
              this.cnData.sbData01.number = result.todayCharge;
              this.cnData.sbData01.unit = result.todayChargeUnit ? result.todayChargeUnit : 'kWh';
              this.cnData.sbData02.number = result.todayDischarge;
              this.cnData.sbData02.unit = result.todayDischargeUnit ? result.todayDischargeUnit : 'kWh';
              this.cnData.sbData04.number = result.totalCharge;
              this.cnData.sbData04.unit = result.totalChargeUnit ? result.totalChargeUnit : 'kWh';
              this.cnData.sbData05.number = result.totalDischarge;
              this.cnData.sbData05.unit = result.totalDischargeUnit ? result.totalDischargeUnit : 'kWh';
              if (powerLine.length > 0) {
                this.echartsLineData.xLabel = [];
                this.echartsLineData.xValue = [];
                powerLine.forEach(item => {
                  let xLabel = COMM.formatDateLine(item.time);
                  this.echartsLineData.xLabel.push(xLabel);
                  this.echartsLineData.xValue.push(item.data);
                });
                if (this.$refs.cnEchartsLine && this.$refs.cnEchartsLine.length > 0) {
                  this.$refs.cnEchartsLine[0].reset();
                }
              }
            }
          }
        });
      },
      //光伏统计
      searchSolarStatistics() {
        let params = {
          projectId: this.projectId
        };
        PROJECTAPI.searchSolarStatistics(params).then(res => {
          if (res.data.code == 200 && res.data.data) {
            let result = res.data.data;
            this.gfData.solarEfficiency.number = (result.solarEfficiency * 100).toFixed(4);
            this.gfData.todayEnergy.number = result.todayEnergy;
            this.gfData.todayEnergy.unit = result.todayEnergyUnit;
            this.gfData.totalEnergy.number = result.totalEnergy;
            this.gfData.totalEnergy.unit = result.totalEnergyUnit;
            if (result && result.solarPower && result.solarPower.length > 0) {
              let solarPower = result.solarPower;
              solarPower.sort(function(a, b) {
                return a.time - b.time;
              });
              this.gfEchartsLineData.xLabel = [];
              this.gfEchartsLineData.xValue = [];
              solarPower.forEach(item => {
                let xLabel = COMM.formatDateLine(item.time);
                this.gfEchartsLineData.xLabel.push(xLabel);
                this.gfEchartsLineData.xValue.push(item.data);
              });
              if (this.$refs.gfEchartsLine) {
                this.$refs.gfEchartsLine[0].reset();
              }
            }
          }
        });
      },
      //市电统计
      searchElectricSupplyStatistics() {
        let params = {
          projectId: this.projectId
        };
        PROJECTAPI.searchElectricSupplyStatistics(params).then(res => {
          if (res.data.code == 200) {
            let result = res.data.data;
            let row1 = [];
            let row2 = [];
            let row3 = [];
            let allrows = [];
            this.cityElectricityData.upData[0].title = '正向有功总电能(' + result.plusEnergyUnit + ')';
            this.cityElectricityData.upData[0].number = result.plusEnergy;
            this.cityElectricityData.upData[1].title = '反向有功总电能(' + result.minusEnergyUnit + ')';
            this.cityElectricityData.upData[1].number = result.minusEnergy;
            result.dataList.forEach((item, index) => {
              if (index < 3) {
                row1.push({
                  title: item.name,
                  number: item.value
                });
              } else if (index > 5) {
                row3.push({
                  title: item.name,
                  number: item.value
                });
              } else {
                row2.push({
                  title: item.name,
                  number: item.value
                });
              }
            });
            allrows = [row1, row2, row3];
            this.cityElectricityData.downData = allrows;
          }
        });
      },
      //储能统计
      searchEnergyStorageStatistics() {
        let params = {
          projectId: this.projectId
        };
        PROJECTAPI.searchEnergyStorageStatistics(params).then(res => {
          if (res.data.code == 200) {
            let result = res.data.data;
            if (result && result.powerLine) {
              let powerLine = result.powerLine;
              this.cnData.sbData01.number = result.todayCharge;
              this.cnData.sbData01.unit = result.todayChargeUnit ? result.todayChargeUnit : 'kWh';
              this.cnData.sbData02.number = result.todayDischarge;
              this.cnData.sbData02.unit = result.todayDischargeUnit ? result.todayDischargeUnit : 'kWh';
              this.cnData.sbData03.number = this.floatMultiply(result.efficiency, 100) + '%';
              this.cnData.sbData04.number = result.totalCharge;
              this.cnData.sbData04.unit = result.totalChargeUnit ? result.totalChargeUnit : 'kWh';
              this.cnData.sbData05.number = result.totalDischarge;
              this.cnData.sbData05.unit = result.totalDischargeUnit ? result.totalDischargeUnit : 'kWh';
              this.cnData.sbData06.number = result.sOC + '%';
              this.cnData.sbData07.number = result.sOH + '%';
              this.echartsLineData.xLabel = [];
              this.echartsLineData.xValue = [];
              let tmpValue = [];
              let tmpLabel = [];
              powerLine.sort(function(a, b) {
                return a.time - b.time;
              });
              powerLine.forEach(item => {
                let xLabel = COMM.formatDateLine(item.time);
                tmpLabel.push(xLabel);
                tmpValue.push([xLabel, item.data]);
              });
              this.echartsLineData.xLabel = Array.from(new Set(tmpLabel));
              this.echartsLineData.xValue = tmpValue;
              this.echartsLineData.yUnit = result.powerUnit;
              if (this.$refs.cnEchartsLine && this.$refs.cnEchartsLine.length > 0) {
                this.$refs.cnEchartsLine[0].reset();
              }
            }
          }
        });
      },
      //处理丢失精度
      floatMultiply(arg1, arg2) {
        arg1 = Number(arg1);
        arg2 = Number(arg2);
        if ((!arg1 && arg1 !== 0) || (!arg2 && arg2 !== 0)) {
          return null;
        }
        arg1 = this.toNonExponential(arg1);
        arg2 = this.toNonExponential(arg2);
        var n1, n2;
        var r1, r2; // 小数位数
        try {
          r1 = arg1.toString().split('.')[1].length;
        } catch (e) {
          r1 = 0;
        }
        try {
          r2 = arg2.toString().split('.')[1].length;
        } catch (e) {
          r2 = 0;
        }
        n1 = Number(arg1.toString().replace('.', ''));
        n2 = Number(arg2.toString().replace('.', ''));
        return (n1 * n2) / Math.pow(10, r1 + r2);
      },
      //转换丢失精度
      toNonExponential(num) {
        var m = num.toExponential().match(/\d(?:\.(\d*))?e([+-]\d+)/);
        return num.toFixed(Math.max(0, (m[1] || '').length - m[2]));
      },
      //市电功率曲线
      searchElectricSupplyPowerCurves() {
        let params = {
          projectId: this.projectId
        };
        PROJECTAPI.searchElectricSupplyPowerCurves(params).then(res => {
          if (res.data.code == 200 && !res.data.errors) {
            let result = res.data.data.powerLine;
            let tmpValue = [];
            let tmpLabel = [];
            // this.sdEchartsLineDataUnit = res.data.data.powerUnit;
            this.sdEchartsLineData.xValue = [];
            this.sdEchartsLineData.xLabel = [];
            result.sort(function(a, b) {
              return a.time - b.time;
            });
            result.forEach(item => {
              let xLabel = COMM.formatDateLine(item.time);
              tmpLabel.push(xLabel);
              tmpValue.push([xLabel, item.data]);
            });
            this.sdEchartsLineData.xLabel = tmpLabel;
            this.sdEchartsLineData.xValue = tmpValue;
            this.sdEchartsLineData.yUnit = res.data.data.powerUnit;
            if (this.$refs.sdEchartsLine && this.$refs.sdEchartsLine.length > 0) {
              this.$refs.sdEchartsLine[0].reset();
            }
          }
        });
      },
      //智慧用能分项收益统计
      projectEarningsStatistics() {
        let tmpData = {};
        let params = {
          projectId: this.projectId
        };
        PROJECTAPI.projectEarningsStatistics(params).then(res => {
          if (res.data.code == 200) {
            tmpData = res.data.data;
            if (tmpData && tmpData.hasOwnProperty('chargingPileIncome')) {
              this.wechartsPieData.pieData[0].value = tmpData.chargingPileIncome;
            }
            if (tmpData && tmpData.hasOwnProperty('energyIncome')) {
              this.wechartsPieData.pieData[1].value = tmpData.energyIncome;
            }
            if (tmpData && tmpData.hasOwnProperty('solarIncome')) {
              this.wechartsPieData.pieData[2].value = tmpData.solarIncome;
            }
          }
        });
      },
      //收益统计
      searchEnergyStorageIncomeStatisticsColumnChart() {
        let params = {
          projectId: this.projectId
        };
        PROJECTAPI.searchEnergyStorageIncomeStatisticsColumnChart(params).then(res => {
          if (res.data.code == 200) {
            if (this.isGDS) {
              if (res.data.data) {
                const result = res.data.data;
                this.echartsPagodaData = result;
                if (result.income) {
                  this.incomeData.incomeData02.number = (result.income / 10000).toFixed(2);
                }
                if (result.incomeChart.data && result.incomeChart.data.length > 0) {
                  const data = result.incomeChart.data;
                  const lastDataItem = data[data.length - 1];
                  this.incomeData.incomeData01.number = Number(lastDataItem).toFixed(2);
                }
              }
              this.reflash('incomeChart', 'reset');
            } else {
              this.echartsPagodaData.income = res.data.data.income;
              this.echartsPagodaData.income = this.dataProcess(this.echartsPagodaData.income);
              if (res.data.data.incomeChart) {
                this.echartsPagodaData.xAxis = res.data.data.incomeChart.timestamps;
                this.echartsPagodaData.series = res.data.data.incomeChart.data;
                if (this.$refs.incomeChart && this.$refs.incomeChart.length > 0) {
                  this.$refs.incomeChart[0].load();
                }
              }
            }
          }
        });
      },
      dataProcess(val) {
        if (val.indexOf('.') != -1) {
          let arr = val.split('.');
          if (arr[0].length > 5) {
            val = (val / 10000).toFixed(2);
            this.incomeTotal = '总收益(万元)';
          } else {
            this.incomeTotal = '总收益(元)';
          }
        } else {
          if (val.length > 5) {
            val = (val / 10000).toFixed(2);
            this.incomeTotal = '总收益(万元)';
          } else {
            this.incomeTotal = '总收益(元)';
          }
        }
        return val;
      },
      //充电桩-待测试
      chargingPileStatistics() {
        let tmpData = {};
        let params = {
          projectId: this.projectId
        };
        PROJECTAPI.chargingPileStatistics(params).then(res => {
          let xValue = [];
          if (res.data.code == 200) {
            tmpData = res.data.data;
            if (tmpData.chargingPileDataList.length > 0) {
              this.cdzData.chargingPileDataList = tmpData.chargingPileDataList;
              this.cdzData.chargingPileDataList.forEach((item, index) => {
                xValue[index] = [];
                let tm = '';
                item.powerData.forEach(it => {
                  tm = this.getTimerHour(it.time);
                  xValue[index].push([tm, it.data]);
                });
              });
            }
          }
        });
      },
      //日充放电
      searchEnergyStorageChargeAndDischargeColumnChart() {
        let params = {
          projectId: this.projectId
        };
        PROJECTAPI.searchEnergyStorageChargeAndDischargeColumnChart(params).then(res => {
          if (res.data.code == 200) {
            this.dayChargingStatisticsData = res.data.data;
            this.reflash('dayPie', 'reset');
          }
        });
      },
      //获取一个时间点
      getTimerHour(date) {
        let tm = new Date(date);
        let hour = tm.getHours();
        let min = tm.getMinutes();
        return hour + '-' + min;
      },
      //获取是否存在
      searchId(order, id) {
        // console.log(order, id);
        // console.log(JSON.stringify(this.authority));
        // this.authority.forEach(item => {
        //   if (item.showOrder == order && item.resourceId == parseInt(id)) {
        //     flag = true;
        //   }
        // });
        var flag = false;
        this.panelIds.forEach(item => {
          if (item.order == order && item.panelId == parseInt(id)) {
            flag = true;
          }
        })
        return flag;
      },
      //刷新控件
      reflash(arg, func) {
        switch (func) {
          case 'reset': {
            if (this.$refs[arg] && this.$refs[arg].length > 0) {
              this.$refs[arg][0].reset();
            }
            break;
          }
          case 'load': {
            if (this.$refs[arg] && this.$refs[arg].length > 0) {
              this.$refs[arg][0].load();
            }
            break;
          }
          case 'init': {
            if (this.$refs[arg] && this.$refs[arg].length > 0) {
              this.$refs[arg][0].init();
            }
            break;
          }
        }
      },
      //获取用户信息
      getUserInfo() {
        let info = getInfo();
        let tp = typeof info;
        if (tp == 'string') {
          this.userInfo = JSON.parse(info);
        }
      },
      //能耗统计
      searchEnergyConsumptionStatistics() {
        let params = {
          projectId: this.projectId
        };
        PROJECTAPI.searchEnergyConsumptionStatistics(params).then(res => {
          if (res.data.code == 200) {
            if (res.data.data) {
              this.annularData.pieData = res.data.data.rankingVos;
              if (this.$refs.echartAnnular) {
                this.$refs.echartAnnular[0].reset();
              }
            }
          }
        });
      },
      //模块点击跳转
      navigateToOtherPage(param) {
        if (this.projectId && this.projectId === '86-071000-012') {
          if (param === '日充放电量') {
            this.$router.push({
              path:"/svolt/electricQuantityAnalysis",
              query: {
                projectId: this.projectId,
              }
            })
          } else if (param === '收益统计') {
            this.$router.push({
              path:"/svolt/income",
              query: {
                appid: 'incomeAssessment',
                projectId: this.projectId,
              }
            })
          }
        }
      },
    },
    created() {
      this.projectId = this.$route.query.projectId;
      if (this.projectId && this.projectId === '86-518045-001') {
        this.isGDS = true;
      }
      for (let i in this.panelIds) {
        for (let j in this.ids) {
          this.panelIds[i].order = Number(this.panelIds[i].type) + 1;
          if (this.panelIds[i].order == this.ids[j]) {
            this.orderIds.push(this.panelIds[i].panelId);
          }
        }
      }
      this.$nextTick(() => {
        this.init();
      })
      // console.log(this.ids)
    },
    mounted() {
      if (this.$refs.incomePiex) {
        this.$refs.incomePiex[0].reset();
      }
      this.interval = setInterval(() => {
        var isClearInterval = sessionStorage.getItem('isClearInterval');
        if (isClearInterval == 0) {
          this.init();
        }
      }, 1000*60*1);

    },
    beforeDestroy() {
      clearInterval(this.interval);
    }
  };
</script>

<style lang="scss" scoped>
  .list-block {
    width: 415px;
    position: absolute;

    .mg2 {
      margin-top: 4px;
    }

    .s-row {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }

    .l-row {
      clear: both;
      height: auto;
      position: relative;
    }

    .l-row-cn {
      clear: both;
      height: 340px;
      position: relative;
    }

    .pagoda-wrap {
      height: 170px;
    }

    .annular-center {
      width: 56px;
      position: absolute;
      top: 116px;
      left: 179px;
      z-index: 999;
    }

    .income-data {
      display: inline-block;
      position: absolute;
      top: 10px;
      right: 10px;

      .income-title {
        height: 16px;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #08265f;
        line-height: 16px;
        text-align: right;
        margin-top: -5px;
      }

      .income-number {
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: bold;
        color: #08265f;
        margin-top: 4px;
      }
    }

    .nh-title {
      width: 215px;
      height: 34px;
      text-align: center;
      line-height: 34px;
      background: linear-gradient(90deg, rgba(8, 74, 147, 0) 0%, rgba(8, 74, 147, 0.64) 37%, rgba(9, 62, 123, 0.67) 65%, rgba(10, 38, 73, 0) 100%);
      font-size: 13px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #08265f;
      margin: 0px auto;
    }

    .bottom10 {
      // min-height: 200px;
      margin-bottom: 10px;
    }

    .s-block {
      width: 64px !important;
    }

    .echarts-line-wrap {
      height: 180px;
      margin-top: 5px;
    }

    .down-block-wrap {
      margin-top: 0px;
      display: flex;
    }

    .shidian {
      height: 200px;
      margin-top: 5px;
    }

    .richongfang {
      height: 230px;
    }

    .zongrongliang {
      height: 173px;
      margin-top: 5px;
    }

    .nenghao {
      margin-top: 5px;
      position: relative;
    }

    .guangfu {
      height: 165px;
      margin-top: 5px;
    }

    .shouyi {
      position: relative;
      height: 37px;
    }

    .annular-wrap {
      position: relative;
      display: inline-block;
      height: 200px;
      // margin-top: 20px;
    }

    .bk-img {
      position: absolute;
      left: 50%;
      bottom: 16px;
      width: 336px;
      transform: translateX(-50%);
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/svolt/project/components/nanwang/list-block.vue